import {
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Stack,
  Switch,
  Typography,
} from "@mui/material";

import { FormFieldIconBox } from "../FormFieldIconBox";
import { LabelRow } from "../LabelRow";

export interface SwitchFieldProps {
  disabled?: boolean;
  value: boolean;
  onChange: (value: boolean) => void;
  error?: { message?: string };
  label: string;
  tooltip?: string;
  switchLabel: string;
  icon?: JSX.Element;
  testId?: string;
}

export const SwitchField = (props: SwitchFieldProps) => {
  const {
    value,
    onChange,
    error,
    disabled,
    label,
    tooltip,
    switchLabel,
    icon,
    testId,
  } = props;

  return (
    <FormGroup data-testid={testId}>
      <LabelRow
        useMuiLabel
        useHtmlLabel={false}
        label={label}
        tooltip={tooltip}
        disabled={disabled}
      />
      {!disabled && (
        <FormControlLabel
          checked={value}
          onChange={(_, checked) => onChange(checked)}
          control={<Switch size="small" />}
          labelPlacement="start"
          disabled={disabled}
          sx={{
            ml: 0,
            pr: 2,
            justifyContent: "space-between",
          }}
          label={
            <Stack
              component="span"
              direction="row"
              spacing={2}
              sx={{ alignItems: "center" }}
            >
              {icon && <FormFieldIconBox icon={icon} />}
              <Typography variant="small" color="secondary.1">
                {switchLabel}
              </Typography>
            </Stack>
          }
        />
      )}
      {error && (
        <FormHelperText error sx={{ mx: 0 }}>
          {error.message}
        </FormHelperText>
      )}
    </FormGroup>
  );
};
